
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 16">
  <path
    d="M1.74999 14C-0.375011 12 -0.250011 8.625 1.74999 6.875L8.24999 0.5L9.24999 1.5C5.37499 5.25 3.24999 7.375 2.74999 7.875C1.99999 8.5 1.62499 9.5 1.62499 10.5C1.62499 11.5 1.99999 12.5 2.74999 13.125C3.49999 13.875 4.24999 14.25 5.49999 14.25C6.74999 14.25 7.74999 13.875 8.49999 13.125L15.875 5.875C16.875 4.875 16.75 3.25 16.125 2.625C15.625 2.125 15.375 1.875 14.625 1.75C14 1.625 13 1.875 12.375 2.5L5.99999 8.75C5.62499 9.125 5.49999 9.625 5.87499 10C6.24999 10.375 6.74999 10.25 7.12499 9.875L12.625 4.5L13.5 5.5L7.99999 10.875C7.49999 11.25 6.24999 12.125 4.87499 11C4.12499 10.125 4.12499 8.75 4.99999 8L11.375 1.75C12.375 0.875 13.25 0.625 14.25 0.625C15.25 0.625 16.125 1.25 16.75 1.875C17.375 2.5 17.625 3.5 17.625 4.375C17.625 5.25 17.25 6.25 16.5 6.875L9.24999 14C8.37499 15 6.99999 15.5 5.49999 15.5C4.12499 15.5 2.74999 15 1.74999 14Z"
    fill="currentColor"
  />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Attachment',
    }) as DefineComponent
    </script>
    